module.exports = __webpack_public_path__ + "assets/favicons/safari-pinned-tab.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/safari-pinned-tab.svg
// module id = SRc6
// module chunks = 1